import { getMe } from './authApi';
import { fetchLicense } from './subscriptionApi';

// Re-hydrates sessionStorage from a still-valid authToken cookie after the
// tab/window was closed and reopened (sessionStorage itself doesn't survive
// that, unlike the cookie). Mirrors what AuthForm.completeLogin() writes on
// a fresh login, including the license cache -- without re-fetching it here,
// a restored session has no license in sessionStorage even though the
// subscription is still active, and pages that read it (DashboardPage,
// ManageCategory) silently treat the account as unsubscribed.
export async function restoreSession() {
  const res = await getMe();
  if (!res.success || !res.user) return null;

  sessionStorage.setItem('isLoggedIn', 'true');
  sessionStorage.setItem('email', res.user.email);
  sessionStorage.setItem('role', res.role || 'user');
  sessionStorage.setItem('theme', res.user.theme || 'light');
  if (res.user.firstName) sessionStorage.setItem('firstName', res.user.firstName);
  if (res.user.lastName) sessionStorage.setItem('lastName', res.user.lastName);

  try {
    const licenseRes = await fetchLicense();
    if (licenseRes.success && licenseRes.license) {
      sessionStorage.setItem('license', JSON.stringify(licenseRes.license));
    }
  } catch {
    // Ignore license fetch errors -- pages fall back to no-license state.
  }

  return res;
}
